<template>
  <div class="notice-box">
    <a-card class="box-card">
      <div
        slot="title"
        class="notice-head clearfix"
      >
        <span>{{ $t('message["1328"]') }}({{ count }})</span>
      </div>
      <div class="notice-list-box scroll_bar_beautify_ff">
        <template v-if="noticeList.length>0">
          <div
            v-for="(item, index) in noticeList"
            :key="index"
            class="text item"
            @click.stop="changeStatus(item, index)"
          >
            <div class="notice-item-con">
              <div class="notice-item-tit clearfix">
                <h2>{{ item.title }}</h2>
                <span class="notice-time">{{ timeTran(item.addtime) }}</span>
              </div>
              <p>{{ item.content }}</p>
            </div>
          </div>
        </template>
        <div
          v-else
          class="no-notice-box"
        >
          <i class="iconfont iconicon-test38" />
          <p>{{ $t('message["1555"]') }}</p>
        </div>
      </div>
      <div
        v-if="noticeList.length>0"
        class="footer"
      >
        <span
          v-if="noticeList.length > 0"
          @click="clearNotice"
        >{{ $t('message["735"]') }}</span>
        <router-link
          slot="extra"
          :to="{ name: 'recordNotice',
                 params: {
                   pid
                 }
          }"
          class="notice-more"
        >
          {{ $t('message["87"]') }}
        </router-link>
      </div>
    </a-card>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'

const FROM_SOPURCE = 'notice'

export default {
  props: {
    defaultinfo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      noticeList: [],
      loading: false,
      count: 0,
      timer: ''
    }
  },
  computed: {
    ...mapState(['baseinfo', 'socketMessage']),
    pid () {
      return this.$store.state.pid
    },
    unreadNum () {
      return this.$store.state.baseinfo.unread_notice_num
    },
    auth () {
      return this.$store.state.auth
    },
    projectid () {
      return this.baseinfo.projectid
    },
    taskId () {
      return this.$t('message["938"]').split('|')
    },
    smartText () {
      return this.$t('message["1248"]')
    }
  },
  watch: {
    socketMessage (data) {
      if (data) {
        const { action, projectid, taskid, finishtime } = data
        if (action === 'notice' && projectid === this.projectid) {
          console.log('gogogog!')
          this.fetchData()
        } else if (action === 'bulkimport' && projectid === this.projectid) { // 批量导入完成
          this.$notification.success({
            message: this.$t('message["712"]'),
            /* description:
            `任务ID：${taskid} &nbsp;&nbsp;&nbsp;&nbsp; 完成时间：${finishtime}`, */
            description: <p style="word-break: break-all;"><span style="margin-right: 10px;">{ this.taskId[0]}{ taskid }</span>{ this.taskId[0]}：{ finishtime }</p>,
            icon: <i class="iconfont iconicon-test94 fs-success" style="font-size: 22px;" />,
            // duration: 300,
            class: 'bulkimportNotification',
            style: {
              width: '460px',
              marginLeft: `${384 - 460}px`
            }
          })
        }
      }
    },
    async unreadNum (newNum) {
      if (newNum) {
        await this.fetchData()
      }
    },
    auth (val) {
      if (!val && this.timer) {
        clearInterval(this.timer)
      }
    }
  },
  async mounted () {
    await this.fetchData()
    // this.timer = setInterval(async () => {
    //   await this.fetchData()
    //   if (!this.auth) {
    //     clearInterval(this.timer)
    //   }
    // }, 60000)
  },
  methods: {
    ...mapActions('notice', ['fetchNoticeDatas', 'delNoticeDatas', 'fetchInquiryDetail']),
    ...mapActions('record', ['updateNoticeStatus']),
    ...mapMutations(['setBaseInfoField', '']),
    async fetchData () {
      this.loading = true
      const chain = await this.fetchNoticeDatas()
      chain.onSuccess(raw => {
        this.noticeList = raw.list
        this.count = raw.count
      })
        .config({ warn: false })
        .fetch()
      this.loading = false
    },
    timeTran (addtime) {
      let time = new Date().getTime()
      // setInterval(() => {
      //   time = time + 60000
      // }, 60000)
      return this.formatDuring(time - addtime * 1000)
    },
    formatDuring (mss) {
      const days = parseInt(mss / (1000 * 60 * 60 * 24))
      const day = days > 0 ? days + this.$t('message["1189"]') : ''
      const hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const hour = hours > 0 ? hours + this.$t('message["1331"]') : ''
      const minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60))
      // const minute = minutes > 0 ? minutes + '分钟' : ''
      // const seconds = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60) / (1000 * 60))
      if (day === '' && hour === '' && minutes === 0) {
        return this.$t('message["348"]')
      } else {
        return day + hour + minutes + this.$t('message["306"]')
      }
    },
    async clearNotice () {
      const chain = await this.delNoticeDatas()
      chain.onSuccess(res => {
        this.noticeList = []
        this.$emit('closeNoticeDialog')
      })
        .fetch()
    },
    async changeStatus (info, index) {
      const { id, title, inquiryid, isread, attribute } = info
      const { followupid = 0, replyid = 0, commentid = 0 } = this.$toType(attribute) === 'object' ? attribute : {}
      // console.log('replyid', replyid)
      let query = {
        type: 'inquiry-manager-all',
        from: FROM_SOPURCE,
        replyid
      }
      if (followupid) {
        query.followupid = followupid
        query.tab2 = 'returnVisite'
      } else if (commentid) {
        query.commentid = commentid
        query.tab2 = 'commentContent'
      }

      isread === 1 && this.toNoticeDetail(title, inquiryid, query)
      if (isread === 0) {
        let params = { id, index }
        const chain = await this.updateNoticeStatus(params)
        chain.onSuccess(async (res) => {
          this.setBaseInfoField({ field: 'unread_notice_num', num: this.baseinfo.unread_notice_num-- })
        })
          .onNetComplete(() => {
            this.toNoticeDetail(title, inquiryid, query)
          })
          .fetch()
      }
    },
    // 跳转到通知详情
    async toNoticeDetail (title, inquiryid, query) {
      if (title.includes(this.$t('message["1500"]'))) {
        this.$router.push({ name: 'ServiceEmail' })
      } else if (title.includes(this.$t('message["251"]'))) {
        this.$router.push({ name: 'ServiceSms' })
      } else if (inquiryid && inquiryid !== 0 && title !== this.smartText) {
        const auditStatus = await this.getInquiryStatus(inquiryid)
        this.$router.push({
          // path: `/project/${this.pid}/inquery/detail/${inquiryid}`,
          name: auditStatus === 1 ? 'InqueryPassDetail' : 'InqueryDetail',
          params: {
            pid: this.pid,
            inquiryId: inquiryid
          },
          query
        })
      } else {
        console.log('万能表单')
      }
    },
    async getInquiryStatus (inquiryid) {
      let params = {
        inquiryid,
        from: 'notice'
      }
      return new Promise(async (resolve, reject) => {
        const chain = await this.fetchInquiryDetail(params)

        chain
          .onSuccess(payload => {
            // console.log(payload)
            let auditStatus = payload && payload.audit_status
            // const arr = Object.keys(payload).map(key => payload[key])
            resolve(auditStatus)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    }
  }
}
</script>
<style lang="scss" scoped >
.notice-box::v-deep {
  position: absolute;
  width: 368px;
  z-index: 1052;
  left: -333px;
  top: 48px;
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;

  .ant-card-bordered {
    border-radius: 4px;
  }

  // .notice-more {
  //   position: absolute;
  //   right: 24px;
  //   top: 10px;
  // }
  .ant-card-head {
    height: 64px;
    font-size: 18px;
    .ant-card-head-title {
      line-height: 32px;
    }
    .notice-head {
      span {
        font-weight: 500;
      }
    }
  }
  .footer {
    height: 64px;
    line-height: 64px;
    text-align: center;
    display: flex;
    .notice-more {
      width: 50%;
      display: inline-block;
      text-align: center;
    }
  }

  .footer span {
    cursor: pointer;
    color: #5077aa;
    width: 50%;
    border-right: 1px solid #ebebeb;
  }

  .ant-card-body {
    padding: 0;
  }
  .item:hover {
    cursor: pointer;
  }
  .item {
    padding: 16px 24px 16px 24px;
    border-bottom: 1px solid #ebebeb;
    position: relative;

    // .notice-icon {
    //   position: absolute;
    //   left: 16px;
    //   width: 32px;
    //   height: 32px;
    //   background: #5a795a;
    //   border-radius: 50%;
    // }

    .notice-item-tit h2 {
      float: left;
      height: 24px;
      line-height: 24px;
      width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
    }

    .notice-time {
      float: right;
      color: #b3b3b3;
      font-size: 12px;
      line-height: 24px;
    }

    p {
      font-size: 12px;
      color: #666;
      height: 32px;
      line-height: 16px;
      overflow: hidden;
      margin-top: 4px;
      width: 276px;
    }
  }

  .notice-list-box {
    max-height: 372px;
    overflow-y: auto;
  }
  .no-notice-box {
    text-align: center;
    color: #b3b3b3;
    padding: 32px 0;
    i {
      font-size: 24px;
    }
  }
}
</style>
<style lang="scss">
.bulkimportNotification {
  .ant-notification-notice-message {
    margin-left: 42px;
    font-weight: bold;
  }
  .ant-notification-notice-description {
    margin-left: 42px;
  }
}
</style>
